import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { GenerationTask, InputSelection } from "../GenerationTask";

/**
 * 生成タスクを作成する。`run=true` で作成と同時に生成開始（待機中へ登録）する。
 *
 * フォーマットの源は **`slideFormatId` か `sourceTaskId` のどちらか**（サーバー側はフラットな
 * 直和として扱い、`sourceTaskId` があるとそちらを優先する）。
 *
 * - 独立実行: `slideFormatId`（現在の PPTX を使い捨てフォーマットとして登録した id）を渡す。
 *   `run=true` は `slideFormatId` 必須、かつ案件に `ready` 受領データ ≥1 が必要。
 * - 再生成: `sourceTaskId` を渡す。本体は実行時にサーバーが元タスクの内部出力から解決するため
 *   アップロードは不要。ただし手元の調整を反映するには **`run` を付けずに作成し、続けて
 *   `putTaskOverrides` で本文と skip を載せ、`updateTask` で開始する**
 *   （[[2026-08-12 設計ノート アドインのAWS連携追随]]）。
 *
 * `inputSelection` は未指定だと「除外なし＝全件」に戻るため、再生成では元タスクの値を渡す。
 */
export async function createTask(
    projectId: string,
    input: {
        slideFormatId?: string;
        label?: string;
        sourceTaskId?: string;
        inputSelection?: InputSelection;
    } = {},
    options: { run?: boolean } = {}
): Promise<GenerationTask> {
    const url = options.run ? "/generation-tasks?run=true" : "/generation-tasks";
    const res = await fetchWithAuth(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ projectId, ...input }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "生成タスクの作成に失敗しました");
    const body = (await res.json()) as { task: GenerationTask };
    return body.task;
}
